module.exports = __webpack_public_path__ + "3b252a1a91262604a52801ec3dda088d.svg";